import React, { useEffect } from 'react'
import { productParamLabel, typeLabel } from '../data/booking_catalog.js'

const SIZE_HELP =
  "If you can’t find the size of Forklift that you require, please call 0800 653 343 to talk to our Team, as we have other sizes available."

export default function EquipmentItemFields({
  item,
  index,
  categoryOptions,
  productsByCategory,
  updateItem,
  showForkliftSizeHelp = false,
  children,
}) {
  const typeMap = productsByCategory[item.category] || {}
  const types = Object.keys(typeMap).filter(Boolean)
  const isForklifts = item.category === 'forklifts'
  const isManual = item.type === 'Manual'
  const models = item.type
    ? typeMap[item.type] || []
    : types.length <= 1
      ? Object.values(typeMap).flat()
      : []
  const showQty = isManual || Boolean(item.model)

  useEffect(() => {
    if (!isManual) return
    const only = (typeMap.Manual || [])[0]
    if (only && item.model !== only.heading) {
      updateItem(index, 'model', only.heading)
    }
  }, [isManual, item.model, index, typeMap.Manual, updateItem])

  return (
    <div className="hire_item_block">
      {index > 0 ? <h4 className="hire_item_title">Item {index + 1}</h4> : null}

      <label className="hire_field">
        <span className="hire_label">Select Equipment Category <span className="req">*</span></span>
        <select value={item.category} onChange={(e) => updateItem(index, 'category', e.target.value)} required>
          {categoryOptions.map((opt) => (
            <option key={opt.value || 'empty'} value={opt.value} disabled={opt.value === ''}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>

      {item.category && types.length > 0 ? (
        <label className="hire_field">
          <span className="hire_label">Category / Type <span className="req">*</span></span>
          <select value={item.type} onChange={(e) => updateItem(index, 'type', e.target.value)} required>
            <option value="" disabled>Select Type</option>
            {types.map((type) => (
              <option key={type} value={type}>{typeLabel(type)}</option>
            ))}
          </select>
        </label>
      ) : null}

      {!isManual && item.category && (item.type || types.length <= 1) ? (
        models.length > 0 ? (
          <label className="hire_field">
            <span className="hire_label">
              Select {productParamLabel(item.category)} <span className="req">*</span>
            </span>
            <select value={item.model} onChange={(e) => updateItem(index, 'model', e.target.value)} required>
              <option value="" disabled>
                Select {productParamLabel(item.category)}
              </option>
              {models.map((m) => (
                <option key={m.slug} value={m.heading}>{m.heading}</option>
              ))}
            </select>
            {showForkliftSizeHelp && isForklifts ? (
              <p className="hire_field_hint">{SIZE_HELP}</p>
            ) : null}
          </label>
        ) : null
      ) : null}

      {showQty ? (
        <label className="hire_field hire_field_qty">
          <span className="hire_label">Quantity <span className="req">*</span></span>
          <select value={item.qty} onChange={(e) => updateItem(index, 'qty', e.target.value)} required>
            {[1, 2, 3, 4, 5].map((n) => (
              <option key={n} value={String(n)}>{n}</option>
            ))}
          </select>
        </label>
      ) : null}

      {children}
    </div>
  )
}
